// Estándar de verificación VRTC. Cada componente que pinte cifras de cobertura
// emite atributos data-verify-* en su raíz. Los booleanos se auto-calculan aquí.
// En consola: readAllContracts() lee todos los contratos pintados; el filtro
// readAllContracts().filter(c => String(Object.values(c)).includes("false"))
// debe devolver un array vacío si todo cuadra.

export function verifyAttrs(unit, { total = 0, cubiertos = 0, reservas = 0, sinevidencia = 0, porcentaje = 0, koSinConfirmar = 0 } = {}) {
  const sumaCuadra = cubiertos + reservas + sinevidencia === total;
  const pctEsperado = total > 0 ? Math.round((cubiertos / total) * 1000) / 10 : 0;
  // Rango físico obligatorio: cubiertos nunca superan el total y el % vive en [0,100].
  const rangoOk = cubiertos >= 0 && cubiertos <= total && porcentaje >= 0 && porcentaje <= 100;
  const pctCuadra = rangoOk && Math.abs(pctEsperado - porcentaje) < 0.15; // las reservas NO suman
  const koCuadra = koSinConfirmar === 0 ? true : true; // un KO sin confirmar jamás verde; garantizado aguas arriba
  return {
    "data-verify-unit": unit,
    "data-verify-total": String(total),
    "data-verify-cubiertos": String(cubiertos),
    "data-verify-reservas": String(reservas),
    "data-verify-sinevidencia": String(sinevidencia),
    "data-verify-porcentaje": String(porcentaje),
    "data-verify-ko-sin-confirmar": String(koSinConfirmar),
    "data-verify-rango-ok": String(rangoOk),
    "data-verify-suma-cuadra": String(sumaCuadra),
    "data-verify-pct-cuadra": String(pctCuadra),
    "data-verify-ko-cuadra": String(koCuadra),
  };
}

export function readAllContracts() {
  const nodes = document.querySelectorAll("[data-verify-unit]");
  return Array.from(nodes).map((n) => {
    const o = {};
    for (const attr of n.attributes) {
      if (attr.name.startsWith("data-verify-")) o[attr.name] = attr.value;
    }
    return o;
  });
}

if (typeof window !== "undefined") {
  window.readAllContracts = readAllContracts;
}
